import { logger } from 'utils/logger';
/**
 * Environment variable validation
 * Throws error if required vars are missing
 */

const requiredEnvVars = ['REACT_APP_BASE_URL'] as const;

const optionalEnvVars = [
  'REACT_APP_SERVICES_BASE_URL',
  'REACT_APP_CAND_URL',
  'REACT_APP_STRAPI_BASE_URL',
  'REACT_APP_N8N_WEBHOOK_URL',
  'REACT_APP_URL_AWS_COGNITO_USER_POOL',
  'REACT_APP_URL_AWS_ORGANIZATION_UUID',
  'REACT_APP_URL_MEETING_PLATFORM',
  'REACT_APP_WEBSOCKET_URL',
  'REACT_APP_HOTJAR_ID',
  'REACT_APP_JITSI_DOMAIN',
] as const;

export const validateEnv = () => {
  const missing = requiredEnvVars.filter(key => !process.env[key]);

  if (missing.length > 0) {
    const errorMsg = `
❌ Missing required environment variables:
${missing.map(key => `  - ${key}`).join('\n')}

Please check your .env file and ensure all required variables are set.
See .env.example for reference.
    `.trim();

    throw new Error(errorMsg);
  }

  // Warn about optional vars
  const missingOptional = optionalEnvVars.filter(key => !process.env[key]);
  if (missingOptional.length > 0 && process.env.NODE_ENV === 'development') {
    logger.warn('⚠️  Optional environment variables not set:', { data: missingOptional });
  }
};

// Export typed env vars matching actual .env file
export const env = {
  baseUrl: process.env.REACT_APP_BASE_URL!,
  servicesBaseUrl: process.env.REACT_APP_SERVICES_BASE_URL,
  candUrl: process.env.REACT_APP_CAND_URL,
  strapiBaseUrl: process.env.REACT_APP_STRAPI_BASE_URL,
  n8nWebhookUrl: process.env.REACT_APP_N8N_WEBHOOK_URL,
  awsCognitoUserPool: process.env.REACT_APP_URL_AWS_COGNITO_USER_POOL,
  awsOrganizationUuid: process.env.REACT_APP_URL_AWS_ORGANIZATION_UUID,
  meetingPlatformUrl: process.env.REACT_APP_URL_MEETING_PLATFORM,
  websocketUrl: process.env.REACT_APP_WEBSOCKET_URL,
  hotjarId: process.env.REACT_APP_HOTJAR_ID,
  jitsiDomain: process.env.REACT_APP_JITSI_DOMAIN || 'meet.jit.si',
} as const;
